import * as pay from "./pay";
import * as nicepayments from "./nicepayments";

export const nice = {
    ...pay,
    ...nicepayments
};
